// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const TextBox = ({ onChange, label, formData, autoFocus, disabled, fullWidth, onPressEnter, placeholder }) => {
  const { errorMsg = "", value = "", required = false } = formData;

  console.log('TextBox: ', formData, value, errorMsg, required, autoFocus);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      console.log("ENTER was pressed: ", e.key);
      onPressEnter && onPressEnter(e);
    }
  };

  return (
    <div className="space-y-2">
      <Input
        id={label}
        autoFocus={autoFocus}
        disabled={disabled}
        value={value || ""}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        className={cn(
          "h-11 border-border focus:border-ring focus:ring-ring",
          fullWidth && "w-full",
          errorMsg && "border-destructive focus:border-destructive focus:ring-destructive",
          disabled && "bg-muted/50 text-muted-foreground cursor-not-allowed"
        )}
        placeholder={placeholder || (label ? `Enter ${label.toLowerCase()}` : "")}
      />
      {errorMsg && (
        <p className="text-sm text-destructive mt-1">{errorMsg}</p>
      )}
    </div>
  );
};

TextBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  formData: PropTypes.shape({
    errorMsg: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
  }).isRequired,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onPressEnter: PropTypes.func
};

TextBox.defaultProps = {
  label: '',
  placeholder: '',
  autoFocus: false,
  disabled: false,
  fullWidth: false,
  onPressEnter: () => {}
};

export default TextBox;
